export function isMobileDevice() {
  return Boolean(window?.navigator?.userAgent?.match(/Mobi/i) ?? false);
}

export function isIpadDevice() {
  return Boolean(window.navigator.userAgent.match(/iPad/i));
}
